/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Form_Name_PlaceholderInputs */

const en_admin_categories_form_name_placeholder = /** @type {(inputs: Admin_Categories_Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category name`)
};

const de_admin_categories_form_name_placeholder = /** @type {(inputs: Admin_Categories_Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Veranstaltung`)
};

/**
* | output |
* | --- |
* | "Category name" |
*
* @param {Admin_Categories_Form_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_categories_form_name_placeholder = /** @type {((inputs?: Admin_Categories_Form_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Form_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_categories_form_name_placeholder(inputs)
	return en_admin_categories_form_name_placeholder(inputs)
});